import { styled } from '@mui/material';
import CardContent from '@mui/material/CardContent';

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(1, 2, 2, 2),
}));
